module.exports = __webpack_public_path__ + "img/quorum.cc95d953.png";